import request from '@aned/request';

/**
 * 连通情况分析
 * @param {*} params
 * @returns
 */
export async function selectRouteLinkAnalyse(params) {
  return request('/api/routeLinkAnalyse/select', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
/**
 * 导出联通明细表
 * @param {*} params
 * @returns
 */
export async function exportRouteLinkAnalyse(params) {
  return request('/api/routeLinkAnalyse/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
